import React, { useState, useEffect } from 'react';
import { Slider } from '@mui/material';
import Cropper from 'react-easy-crop';
 import { Area } from 'react-easy-crop/types';
import styles from './imageCropper.module.scss';

interface ImageCropperProps {
  image: string;
  onCropComplete?: (croppedArea: any, croppedAreaPixels: any) => void;
  aspect?: number;
  cropShape?: 'rect' | 'round';
}

const ImageCropper: React.FC<ImageCropperProps> = ({
  image,
  onCropComplete,
  aspect = 1,
  cropShape = 'rect',
}) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  
  useEffect(() => {
    if (image) {
      setZoom(1);
      setCrop({ x: 0, y: 0 });
    }
  }, [image]);

  const handleCropChange = (crop: { x: number; y: number }) => {
    setCrop(crop);
  };

  const handleCropComplete = (croppedArea: Area, croppedAreaPixels: Area) => {
    if (onCropComplete) {
      onCropComplete(croppedArea, croppedAreaPixels);
    }
  };

  const handleZoomChange = (zoom: number) => {
    setZoom(zoom);
  };

  return (
    <div className={styles.imageCropper}>
      <div className={styles.cropContainer}>
        <Cropper
          image={image}
          crop={crop}
          zoom={zoom}
          aspect={aspect}
          cropShape={cropShape}
          showGrid={false}
          onCropChange={handleCropChange}
          onCropComplete={handleCropComplete}
          onZoomChange={handleZoomChange}
          objectFit="horizontal-cover"
          style={{
            containerStyle: {
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            },
            cropAreaStyle: {
              width: '100%',
              height: '33.3%',
              color: 'rgba(80, 80, 80, 0.8)',
              border: '2px solid rgba(80, 80, 80, 0.8)',
              borderRadius: cropShape === 'round' ? '20%' : '100px',
            },
            mediaStyle: {
              width: '100%',
              height: 'auto',
              objectFit: 'cover',
            }
          }}
        />
      </div>
      <div className={styles.controls}>
        <Slider
          value={zoom}
          min={1}
          max={3}
          step={0.01}
          aria-labelledby="Zoom"
          onChange={(_: Event, value: number | number[]) => handleZoomChange(value as number)}
          className={styles.slider}
        />
      </div>
    </div>
  );
};

export default ImageCropper;
